import { DomImagesContext } from './domImagesContext';
import { RecolorContext } from './recolorContext';

export type RecolorModuleOptions = {
  domImagesContext?: DomImagesContext;
  numThreads?: number;
};

export class RecolorModule {
  /** DOM images resources context. */
  private static domImagesContext: DomImagesContext;
  /** Recolor resources context. */
  private static context_: RecolorContext;

  /**
   * Returns the recolor context.
   */
  static get context() {
    return this.context_;
  }

  /**
   * Init module.
   */
  static async init(options?: RecolorModuleOptions) {
    this.domImagesContext = options?.domImagesContext ?? new DomImagesContext();
    this.context_ = new RecolorContext(this.domImagesContext);

    // Wait for worker threads initialization
    await this.context_.init();
  }

  /**
   * Release module.
   */
  static async dispose() {
    await this.context_.dispose();
  }
}
